import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useResolution } from '../hooks/useResolution';
import { useAtomValue } from 'jotai';
import { atomGameTheme } from '../states/game.atoms';
import { useAssets } from './AssetHandler';

export const BackgroundLayer: React.FC = () => {
  const { isMobile } = useResolution()
  const theme = useAtomValue(atomGameTheme);
  const { assets } = useAssets();

  if (isMobile) {
    return (
      <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none z-0">
        <AnimatePresence>
          {theme === 'day' && (
            <motion.div
              key="day"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              className="absolute inset-0 w-full h-full"
            >
              <img
                className="w-full h-full object-cover"
                src='/blinko/bg-day.jpg'
                alt="Day background"
              />
            </motion.div>
          )}
          {theme === 'night' && (
            <motion.div
              key="night"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              transition={{ duration: 1 }}
              className="absolute inset-0 w-full h-full"
            >
              <img
                className="w-full h-full object-cover"
                src='/blinko/bg-night.jpg'
                 alt="Night background"
              />
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    )
  }

  return (
    <div className="absolute inset-0 w-full h-full overflow-hidden pointer-events-none z-0">
      <AnimatePresence>
        {theme === 'day' && (
          <motion.div
            key="day"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 w-full h-full"
          >
            <video
              className="w-full h-full object-cover"
              loop
              muted
              autoPlay
              playsInline
              preload="auto"
              poster='/blinko/bg-day.jpg'
            >
               <source src="/blinko/bg-day.mp4" type="video/mp4" />
            </video>
          </motion.div>
        )}
        {theme === 'night' && (
          <motion.div
            key="night"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            className="absolute inset-0 w-full h-full"
          >
            <video
              className="w-full h-full object-cover"
              loop
              muted
              autoPlay
              playsInline
              preload="auto"
              poster='/blinko/bg-night.jpg'
            >
               <source src={assets?.videos['bg-night-video'] ?? "/blinko/bg-night.mp4"} type="video/mp4" />
            </video>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};
